import { createContext, ReactNode, useContext, useRef, useState } from "react";

export const LoadDataContext = createContext<any>(null);
export const LoadDataContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const handleRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  const playerRef: any = useRef();
  return (
    <LoadDataContext.Provider
      value={{ handleRefresh: handleRefresh, isRefresh: isRefresh, playerRef }}
    >
      {children}
    </LoadDataContext.Provider>
  );
};
export const useLoadData = () => {
  const context = useContext(LoadDataContext);
  return context;
};
